import { Component, OnInit, OnDestroy } from '@angular/core';
import { IStockComm, IStockFileContent, IStockFileEntry, IStockFolder, IStockTreeElement, IUserLocale, IxellAPIService, Roles } from 'src/app/tools/api.service'
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { HttpEventType, HttpRequest, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { CLOUD_MAX_FILE_SIZE, downloadBase64File, MIN_COUNTRY_MODE } from '../utils/utils';
import { StorageService } from '../../tools/storage.service';

export type CountryInfo = {
    idPays: number,
    pays: string
};

export type LanguageInfo = {
    idLangue: number,
    langue: string,
};

export type GroupedLocale = CountryInfo & {
    langues: LanguageInfo[]
};

export type LocalePair = CountryInfo & LanguageInfo;

export type LocaleRedirection = { from: LocalePair, to: LocalePair };

export type ReferenceFile = {
    country: number,
    language: number,
    title: string,
    file: File
}

export type FileEditModalResult = {
    file: IStockFileEntry,
    folder: IStockFolder,
    data: ReferenceFile[],
    formStatusChanger: (state: boolean | string) => void
}

export type FileTranslateModalResult = {
    file: IStockFileEntry,
    folder: IStockFolder,
    data: ReferenceFile,
    formStatusChanger: (state: boolean | string) => void
}

export type FileCreateModalResult = {
    folder: IStockFolder,
    data: ReferenceFile[],
    formStatusChanger: (state: boolean | string) => void
}

export type FileDeleteModalResult = {
    id: number,
    folder: IStockFolder,
    formStatusChanger: (state: boolean) => void
}

export type FileCreateCommModalResult = {
    id: number,
    folder: IStockFolder,
    data: File[],
    kind: number,
    title: string,
    start: Date,
    end: Date,
    tariff: string,
    tech: string,
    country: number,
    formStatusChanger: (state: boolean | string) => void
}

@Component({
    selector: 'app-cloud',
    templateUrl: './cloud.component.html',
    styleUrls: ['./cloud.component.scss'],
})
export class CloudComponent implements OnInit, OnDestroy {
    MIN_COUNTRY_MODE = MIN_COUNTRY_MODE;

    role: Roles = Roles.Unknown;
    Utils = Utils;

    //country: string = '';

    displayModalAddFile: boolean = false;
    displayModalEditFile: boolean = false;
    displayModalDeleteFile: boolean = false;
    displayModalTranslateFile: boolean = false;
    displayModalAddCommFile: boolean = false;
    showTree: boolean = false;
    adminKind: number = 3;

    editingFolder: IStockFolder | null = null;
    editingFile: IStockFileEntry | null = null;
    editingComm: IStockComm | null = null;
    editingProgress: number = 0;

    // Objet
    treeStructure: MatTreeNestedDataSource<IStockFolder> = new MatTreeNestedDataSource<IStockFolder>();
    languageRedirects: { [lang: number]: number } = {};
    languageRedirectsPending: { [lang: number]: number } = {};
    myLocale: IUserLocale;
    possibleLocales: { [key: number]: GroupedLocale } = {};
    tarifCategories: { [idPays: number]: string[] } = null;
    availableTechnologies: { name: string, code: string } [] = null;

    readonly techTranslation = {
        'IX-T': { name: 'IxellTech', order: 1 },
        'OX': { name: 'Oxelia', order: 2 },
        'HS2': { name: 'HS 2', order: 3 },
        'EquinoxWaterbase': { name: 'Equinox Waterbase', order: 4 },
        'EquinoxSolid': { name: 'Equinox Solid', order: 5 }
    };

    // Form controls
    readonly selectedCountry = new FormControl<number>(null, [Validators.required]);
    readonly selectedLanguage = new FormControl<number>(null, [Validators.required, (control: AbstractControl): ValidationErrors | null => {
        if (!this.possibleLocales || !this.selectedCountry.value || !this.possibleLocales[this.selectedCountry.value].langues.some(l => l.idLangue === control.value))
            return { required: true };

        return null;
    }]);
    showUnlisted = false;

    getDisplayColumns(mode: number) {
        if (this.adminKind == 3) {
            //const isFrance = (this.selectedCountry.value === 75 && this.selectedLanguage.value === 1);

            let tbl2 = [];
            if (mode == 4) {
                tbl2 = ["title", "startDate", "endDate", "read"];
            } else {
                tbl2 = ["name", "lastEdit", "read"];
            }
            return tbl2;
        } else {

            const isFrance = (this.selectedCountry.value === 75 && this.selectedLanguage.value === 1);
            const tbl = [
                (mode === 4) ? 'title' : 'name',
                (mode === 4) ? 'startDate' : 'lastEdit',
                (mode === 4) ? 'endDate' : 'unlisted',
                (mode === 4 && this.adminKind !== 3) ? 'edit' : 'read'];

            if (mode !== 4)
                tbl.push((isFrance || mode > 1) ? 'edit' : 'translate');

            if ((isFrance && this.adminKind < 2 && mode < 4) || (this.adminKind == 0) || (mode === 4 && this.adminKind <= 2))
                tbl.push('delete');

            return tbl;
        }
    }

    // Sub
    private roleSub: any;
    private getMyLocaleSub: any;
    private getCloudTreeSub: any;
    private getPossibleLocalesSub: any;
    private addCloudFileSub: any;
    private editCloudFileSub: any;
    private translateCloudFileSub: any;
    private deleteCloudFileSub: any;
    private addCloudCommSub: any;
    private deleteCloudCommSub: any;
    private changeFileContentListingSub: any;
    private changeCloudTreeDefaultLanguageSub: any;
    private getTarifCategoriesForAllCountriesSub: any;
    private getAvailableTechnologiesSub: any;
    private getCloudCommFileSub: any;

    // Callbacks
    treeControl = new NestedTreeControl<IStockTreeElement | IStockFileEntry | IStockFolder>((node: IStockTreeElement | IStockFileEntry | IStockFolder) => ('children' in node) ? (node.children ?? []) : []);
    hasChild = (_: number, node: IStockFileEntry | IStockFolder) => ('children' in node)/* && !!node.children && node.children.length > 0*/;

    constructor(private readonly headerService: HeaderService, private readonly apiService: IxellAPIService, private translateService: TranslateService, private readonly httpClient: HttpClient, private storage: StorageService) { }

    ngOnInit() {

        //this.country = this.storage.get("country")

        this.headerService.changeCanBack(true);
        this.headerService.changeTitle("common.cloud");
        this.headerService.changeLogo("");

        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);

        if (Utils.isAdminLacour(this.role)) {
            this.adminKind = 0;
        } else if (Utils.isAdminRenault(this.role)) {
            this.adminKind = 1;
        } else if (Utils.isAdminRenaultPays(this.role)) {
            this.adminKind = 2;
        } else {
            this.adminKind = 3;
        }

        this.getCloudTreeSub = this.apiService.getCloudTree().subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log("getCloudTree()");
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);

            this.languageRedirects = {};
            this.languageRedirectsPending = {};
            for (const r of data.redirects) {
                this.languageRedirects[r.srcLang] = r.dstLang;
                this.languageRedirectsPending[r.srcLang] = r.dstLang;
            }

            this.treeStructure.data = data.roots;
            this.showTree = true;

            if (this.getCloudTreeSub != null) this.getCloudTreeSub.unsubscribe();
        }, error => {
            if (this.getCloudTreeSub != null) this.getCloudTreeSub.unsubscribe();
        })

        this.getPossibleLocalesSub = this.apiService.getPossibleLocales().subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log("getPossibleLocales()");
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);
            this.possibleLocales = {};
            for (let locale of data) {
                if (locale.idPays in this.possibleLocales)
                    this.possibleLocales[locale.idPays].langues.push({ idLangue: locale.idLangue, langue: locale.langue });
                else
                    this.possibleLocales[locale.idPays] = { idPays: locale.idPays, pays: locale.pays, langues: [{ idLangue: locale.idLangue, langue: locale.langue }] };
            }

            this.getMyLocaleSub = this.apiService.getMyLocale().subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log("getMyLocale()");
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                this.myLocale = data;
                this.selectedCountry.setValue(data.idPays);
                this.selectedLanguage.setValue(data.idLangue);

                ///*----------------------------------------------------------------------------------------------------*/console.log("this.possibleLocales");
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.possibleLocales);

                if (!Utils.isAdminLacour(this.role) && !Utils.isAdminRenault(this.role) && !Utils.isAttum(this.role)) {
                    ///*----------------------------------------------------------------------------------------------------*/console.log(this.possibleLocales[data.idPays]);
                    var tmp = this.possibleLocales[data.idPays];
                    this.possibleLocales = {};
                    this.possibleLocales[data.idPays] = { idPays: tmp.idPays, pays: tmp.pays, langues: tmp.langues };

                    ///*----------------------------------------------------------------------------------------------------*/console.log(this.possibleLocales);
                }

                if (this.getMyLocaleSub != null) this.getMyLocaleSub.unsubscribe();
            }, error => {
                if (this.getMyLocaleSub != null) this.getMyLocaleSub.unsubscribe();
            });

            if (this.getPossibleLocalesSub != null) this.getPossibleLocalesSub.unsubscribe();
        }, error => {
            if (this.getPossibleLocalesSub != null) this.getPossibleLocalesSub.unsubscribe();
        })

    }

    doesTreeElemContainFiles(treeElem: IStockFolder): boolean {
        return (treeElem.children.length === 0) || treeElem.children.some(c => ('contents' in c) || ('idStockComm' in c));
    }

    getTreeElemFiles(treeElem: IStockFolder): (IStockFileEntry | IStockComm)[] {
        return treeElem.children.filter(c => ('contents' in c && (this.showUnlisted || (c as IStockFileEntry).contents.some(ctn => (treeElem.mode < MIN_COUNTRY_MODE || ctn.paysId === this.selectedCountry.value) && (treeElem.mode >= MIN_COUNTRY_MODE || ctn.langId === this.selectedLanguage.value)))) || ('idStockComm' in c)) as (IStockFileEntry | IStockComm)[];
    }

    getFileContent(file: IStockFileEntry, mode: number): IStockFileContent {
        return file.contents.find(ctn => (mode < MIN_COUNTRY_MODE || ctn.paysId === this.selectedCountry.value) && (mode >= MIN_COUNTRY_MODE || ctn.langId === this.selectedLanguage.value));
    }

    haveTraduction(file: IStockFileEntry): boolean {
        if (file.discriminator == "IStockFileEntry") {
            return file.contents.findIndex(ctn => ctn.content != "" && ctn.langId == 2) > -1;
        } else {
            return true;
        }
    }

    getDefaultFileContent(file: IStockFileEntry, mode: number) {
        return (mode < MIN_COUNTRY_MODE) ? file.contents.find(ctn => ctn.langId === this.languageRedirects[this.selectedLanguage.value]) : null;
    }

    getDownloadableFileContent(file: IStockFileEntry , mode: number): IStockFileContent {
        const ctn = this.getFileContent(file, mode);
        if (!ctn.content.length) {
            return this.getDefaultFileContent(file, mode);
        }

        return ctn;
    }

    readElem(file: IStockFileEntry | IStockComm, mode: number) {
        if ('idStockComm' in file) {
            this.editingProgress = 0;
            this.editingFolder = null;
            this.editingFile = null;
            this.editingComm = file;
            this.actAfterInitializingComms(() => {
                this.displayModalAddCommFile = true;
            });
        }
        else if (file.contents.length > 0) {
            const ctn = this.getDownloadableFileContent(file, mode);
            window.open(ctn.url, "_blank");
        }
    }

    createFile(folder: IStockFolder) {
        this.editingProgress = 0;
        this.editingFolder = folder;
        this.displayModalAddFile = true;
    }

    editElem(file: IStockFileEntry | IStockComm, folder: IStockFolder) {

        ///*----------------------------------------------------------------------------------------------------*/console.log("file", file);
        ///*----------------------------------------------------------------------------------------------------*/console.log("folder", folder);

        this.editingProgress = 0;
        this.editingFolder = folder;

        if ('idStockComm' in file) {
            this.editingFile = null;
            this.editingComm = file;
            this.actAfterInitializingComms(() => {
                this.displayModalAddCommFile = true;
            });
        }
        else {
            this.editingComm = null;
            this.editingFile = file;
            this.displayModalEditFile = true;
        }
    }

    translateElem(file: IStockFileEntry, folder: IStockFolder) {
        this.editingProgress = 0;
        this.editingFile = file;
        this.editingFolder = folder;
        this.displayModalTranslateFile = true;
    }

    deleteElem(file: IStockFileEntry | IStockComm, folder: IStockFolder) {
        this.editingProgress = 0;

        if ('idStockComm' in file) {
            this.editingFile = null;
            this.editingComm = file;
        }
        else {
            this.editingComm = null;
            this.editingFile = file;
        }

        this.editingFolder = folder;
        this.displayModalDeleteFile = true;
    }

    actAfterInitializingComms(cb: () => void) {
        if (!this.tarifCategories) {
            const idsPays: number[] = [];
            for (const keyC in this.possibleLocales)
                idsPays.push(this.possibleLocales[keyC].idPays);

            this.getTarifCategoriesForAllCountriesSub = this.apiService.getTarifCategoriesForAllCountries(idsPays).subscribe(data1 => {
                ///*----------------------------------------------------------------------------------------------------*/console.log("getTarifCategoriesForAllCountries()");
                ///*----------------------------------------------------------------------------------------------------*/console.log(data1);

                this.tarifCategories = data1;

                if (!this.availableTechnologies) {
                    this.getAvailableTechnologiesSub = this.apiService.getAvailableTechnologies().subscribe(data2 => {
                        ///*----------------------------------------------------------------------------------------------------*/console.log("getAvailableTechnologies()");
                        ///*----------------------------------------------------------------------------------------------------*/console.log(data2);
                        data2.sort((a, b) => this.techTranslation[a].order - this.techTranslation[b].order);
                        this.availableTechnologies = data2.map(tech => ({ code: tech, name: this.techTranslation[tech].name }));

                        cb();

                        if (this.getAvailableTechnologiesSub != null) this.getAvailableTechnologiesSub.unsubscribe();
                    }, error => {
                        alert(this.translateService.instant('cloud.errors.cantGetTechs'));
                        if (this.getAvailableTechnologiesSub != null) this.getAvailableTechnologiesSub.unsubscribe();
                    })
                }
                else
                    cb();

                if (this.getTarifCategoriesForAllCountriesSub != null) this.getTarifCategoriesForAllCountriesSub.unsubscribe();
            }, error => {
                alert(this.translateService.instant('cloud.errors.cantGetTariffs'));
                if (this.getTarifCategoriesForAllCountriesSub != null) this.getTarifCategoriesForAllCountriesSub.unsubscribe();
            })
        }
        else
            cb();
    }

    createCommFile(folder: IStockFolder) {
        this.editingProgress = 0;
        this.editingFolder = folder;
        this.editingComm = null;

        this.actAfterInitializingComms(() => {
            this.displayModalAddCommFile = true;
        })
    }

    saveEditFile({ file, folder, data, formStatusChanger }: FileEditModalResult) {
        formStatusChanger(true);

        const formData = new FormData();
        const headers = new Headers();
        headers.set('Accept', 'application/json');
        headers.delete('Content-Type');

        let fileIdx = 0;

        formData.append('fileEntry', file.idStockFileEntry.toString());
        for (const reference of data) {
            formData.append('countries', reference.country.toString());
            formData.append('languages', reference.language.toString());
            formData.append('titles', reference.title.toString());
            formData.append('fileIndices', reference.file ? fileIdx.toString() : "-1");
            if (reference.file) {
                formData.append('files', reference.file);
                fileIdx++;
            }
        }

        this.editingProgress = -1;
        const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/EditCloudFile", formData, { reportProgress: true,  });
        this.editCloudFileSub = this.httpClient.request(uploadReq).subscribe(event => {
            switch (event.type) {
                case HttpEventType.UploadProgress: {
                    this.editingProgress = (event.total) ? Math.round((event.loaded / event.total) * 100) : -1;
                    break;
                }
                case HttpEventType.ResponseHeader: {
                    this.editingProgress = 100;
                    break;
                }
                case HttpEventType.DownloadProgress: {
                    this.editingProgress = 100;
                    break;
                }
                case HttpEventType.Response: {
                    this.editingProgress = 100;
                    if (event.ok) {
                        const newEntry = IStockFileEntry.fromJS(event.body);

                        file.contents = newEntry.contents;

                        this.closeModal();
                    }
                    else {
                        this.handleErrorStatus(event.status, formStatusChanger, data.length > 1, 'edit');
                    }

                    if (this.editCloudFileSub != null) this.editCloudFileSub.unsubscribe();
                    break;
                }
            }
        }, error => {
            this.editingProgress = 100;
            this.handleErrorStatus(error.status, formStatusChanger, data.length > 1, 'edit');
        });
    }

    saveTranslateFile({ file, folder, data, formStatusChanger }: FileTranslateModalResult) {
        formStatusChanger(true);

        const formData = new FormData();
        const headers = new Headers();
        headers.set('Accept', 'application/json');
        headers.delete('Content-Type');

        formData.append('fileEntry', file.idStockFileEntry.toString());
        formData.append('country', data.country.toString());
        formData.append('language', data.language.toString());
        if (data.title)
            formData.append('title', data.title.toString());
        if (data.file)
            formData.append('file', data.file);

        this.editingProgress = -1;
        const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/TranslateCloudFile", formData, { reportProgress: true });
        this.translateCloudFileSub = this.httpClient.request(uploadReq).subscribe(event => {
            switch (event.type) {
                case HttpEventType.UploadProgress: {
                    this.editingProgress = (event.total) ? Math.round((event.loaded / event.total) * 100) : -1;
                    break;
                }
                case HttpEventType.ResponseHeader: {
                    this.editingProgress = 100;
                    break;
                }
                case HttpEventType.Response: {
                    this.editingProgress = 100;
                    if (event.ok) {
                        const newEntry = IStockFileEntry.fromJS(event.body);

                        file.contents = newEntry.contents;

                        this.closeModal();
                    }
                    else {
                        this.handleErrorStatus(event.status, formStatusChanger, false, 'translate');
                    }

                    if (this.translateCloudFileSub != null) this.translateCloudFileSub.unsubscribe();
                    break;
                }
            }
        }, error => {
            this.editingProgress = 100;
            this.handleErrorStatus(error.status, formStatusChanger, false, 'translate');
        });
    }

    saveCreateFile({ folder, data, formStatusChanger }: FileCreateModalResult) {
        formStatusChanger(true);

        const formData = new FormData();
        const headers = new Headers();
        headers.set('Accept', 'application/json');
        headers.delete('Content-Type');

        let fileIdx = 0;

        formData.append('folderEntry', folder.idStockFolder.toString());
        for (const reference of data) {
            formData.append('countries', reference.country.toString());
            formData.append('languages', reference.language.toString());
            formData.append('titles', reference.title.toString());
            formData.append('fileIndices', reference.file ? fileIdx.toString() : "-1");
            if (reference.file) {
                formData.append('files', reference.file);
                fileIdx++;
            }
        }

        this.editingProgress = -1;
        const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/AddCloudFile", formData, { reportProgress: true });
        this.addCloudFileSub = this.httpClient.request(uploadReq).subscribe(event => {
            switch (event.type) {
                case HttpEventType.UploadProgress: {
                    this.editingProgress = (event.total) ? Math.round((event.loaded / event.total) * 100) : -1;
                    break;
                }
                case HttpEventType.ResponseHeader: {
                    this.editingProgress = 100;
                    break;
                }
                case HttpEventType.Response: {
                    this.editingProgress = 100;
                    if (event.ok) {
                        const newEntry = IStockFileEntry.fromJS(event.body);

                        folder.children.push(newEntry);

                        this.closeModal();
                    }
                    else {
                        this.handleErrorStatus(event.status, formStatusChanger, data.length > 1, 'create');
                    }

                    if (this.addCloudFileSub != null) this.addCloudFileSub.unsubscribe();
                    break;
                }
            }
        }, error => {
            this.editingProgress = 100;
            this.handleErrorStatus(error.status, formStatusChanger, data.length > 1, 'create');
        });
    }

    saveCreateCommFile({ id, folder, data, kind, title, start, end, tariff, tech, country, formStatusChanger }: FileCreateCommModalResult) {
        formStatusChanger(true);

        console.log(data);

        const formData = new FormData();
        const headers = new Headers();
        headers.set('Accept', 'application/json');
        headers.delete('Content-Type');

        let fileIdx = 0;

        if (id)
            formData.append('id', id.toString());

        formData.append('folder', folder.idStockFolder.toString());
        formData.append('kind', kind.toString());
        formData.append('title', title);
        formData.append('start', start.toUTCString());
        formData.append('end', end.toUTCString());
        formData.append('tariff', tariff);
        formData.append('tech', tech);
        formData.append('country', country.toString());
        for (const file of data) {
            formData.append('fileIndices', file ? fileIdx.toString() : "-1");
            if (file) {
                formData.append('files', file);
                fileIdx++;
            }
        }

        this.editingProgress = -1;
        const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/AddOrEditCloudComm", formData, { reportProgress: true });
        this.addCloudCommSub = this.httpClient.request(uploadReq).subscribe(event => {
            switch (event.type) {
                case HttpEventType.UploadProgress: {
                    this.editingProgress = (event.total) ? Math.round((event.loaded / event.total) * 100) : -1;
                    break;
                }
                case HttpEventType.ResponseHeader: {
                    this.editingProgress = 100;
                    break;
                }
                case HttpEventType.Response: {
                    this.editingProgress = 100;
                    if (event.ok) {
                        const newEntry = IStockComm.fromJS(event.body);

                        if (id)
                            folder.children[folder.children.findIndex(child => 'idStockComm' in child && (child as IStockComm).idStockComm === id)] = newEntry;
                        else
                            folder.children.push(newEntry);

                        this.closeModal();
                    }
                    else {
                        this.handleErrorStatus(event.status, formStatusChanger, data.length > 1, 'createComm');
                    }

                    if (this.addCloudCommSub != null) this.addCloudCommSub.unsubscribe();
                    break;
                }
            }
        }, error => {
            this.editingProgress = 100;
            this.handleErrorStatus(error.status, formStatusChanger, data.length > 1, 'createComm');
        });
    }

    deleteFile({ id, folder, formStatusChanger }: FileDeleteModalResult) {
        formStatusChanger(true);

        this.editingProgress = -1;

        if (this.editingFile) {
            this.deleteCloudFileSub = this.apiService.deleteCloudFile(id).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log("deleteCloudFile()");
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                this.editingProgress = 100;
                if (data) {
                    folder.children = folder.children.filter(child => (child as any)._discriminator !== "IStockFileEntry" || (child as IStockFileEntry).idStockFileEntry !== id)
                    this.closeModal();
                }
                else {
                    formStatusChanger(false);
                }

                if (this.deleteCloudFileSub != null) this.deleteCloudFileSub.unsubscribe();
            }, error => {
                this.editingProgress = 100;
                formStatusChanger(false);
                if (this.deleteCloudFileSub != null) this.deleteCloudFileSub.unsubscribe();
            })
        }
        else if (this.editingComm) {

            this.deleteCloudCommSub = this.apiService.deleteCloudComm(id, folder.idStockFolder).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log("deleteCloudComm()");
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                this.editingProgress = 100;
                if (data) {
                    folder.children = folder.children.filter(child => (child as any)._discriminator !== "IStockComm" || (child as IStockComm).idStockComm !== id)
                    this.closeModal();
                }
                else {
                    formStatusChanger(false);
                }

                if (this.deleteCloudCommSub != null) this.deleteCloudCommSub.unsubscribe();
            }, error => {
                this.editingProgress = 100;
                formStatusChanger(false);
                if (this.deleteCloudCommSub != null) this.deleteCloudCommSub.unsubscribe();
            })
        }
    }

    handleErrorStatus(status: number, formStatusChanger: (state: boolean | string) => void, isMultiple: boolean, origin: 'create'|'edit'|'translate'|'createComm') {
        switch (status) {
            case 400: // Bad request
            {
                formStatusChanger(this.translateService.instant('cloud.errors.unknown'));
                break;
            }
            case 413: // Payload too large
            {
                formStatusChanger(this.translateService.instant(
                    isMultiple ? 'cloud.errors.payloadTooLarge' : 'cloud.errors.fileTooBig',
                    {
                        size: (CLOUD_MAX_FILE_SIZE / 1048576).toLocaleString(this.translateService.currentLang, {
                            minimumIntegerDigits: 1,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        })
                    }
                ));
                break;
            }
            case 422: // Unprocessable entity
            {
                formStatusChanger(this.translateService.instant(isMultiple ? 'cloud.errors.unprocessableEntity' : 'cloud.errors.invalidExtension'));
                break;
            }
            case 500: // Internal processing error
            {
                formStatusChanger(this.translateService.instant('cloud.errors.internalProcessingError'));
                break;
            }
            case 507: // Insufficient storage
            {
                formStatusChanger(this.translateService.instant('cloud.errors.insufficientStorage'));
                break;
            }
            default:
            {
                formStatusChanger(this.translateService.instant('cloud.errors.unknown'));
                break;
            }
        }
    }

    executePendingLanguageChange() {
        if (this.languageRedirects[this.selectedLanguage.value] === this.languageRedirectsPending[this.selectedLanguage.value])
            return;

        this.changeCloudTreeDefaultLanguageSub = this.apiService.changeCloudTreeDefaultLanguage(this.selectedLanguage.value, this.languageRedirectsPending[this.selectedLanguage.value]).subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log("changeCloudTreeDefaultLanguage()");
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);
            if (data) {
                this.languageRedirects[this.selectedLanguage.value] = this.languageRedirectsPending[this.selectedLanguage.value];
            }
            else {
                this.languageRedirectsPending[this.selectedLanguage.value] = this.languageRedirects[this.selectedLanguage.value];
            }

            if (this.changeCloudTreeDefaultLanguageSub != null) this.changeCloudTreeDefaultLanguageSub.unsubscribe();
        }, error => {
            if (this.changeCloudTreeDefaultLanguageSub != null) this.changeCloudTreeDefaultLanguageSub.unsubscribe();
        })

    }

    changeListing(event: PointerEvent, target: MatCheckbox, child: IStockFileEntry, mode: number) {
        event.preventDefault();

        target.setDisabledState(true);

        const ctn = this.getFileContent(child, mode);

        this.changeFileContentListingSub = this.apiService.changeCloudFileContentListing(ctn.idStockFileContent, !ctn.unlisted).subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log("changeCloudFileContentListing()");
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);
            ctn.unlisted = data;
            target._inputElement.nativeElement.checked = data;
            target.checked = data;
            target.setDisabledState(false);

            if (this.changeFileContentListingSub != null) this.changeFileContentListingSub.unsubscribe();
        }, error => {
            target.setDisabledState(false);
            if (this.changeFileContentListingSub != null) this.changeFileContentListingSub.unsubscribe();
        });
    }

    ngOnDestroy() {
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.getMyLocaleSub != null) this.getMyLocaleSub.unsubscribe();
        if (this.getCloudTreeSub != null) this.getCloudTreeSub.unsubscribe();
        if (this.getPossibleLocalesSub != null) this.getPossibleLocalesSub.unsubscribe();
        if (this.addCloudFileSub != null) this.addCloudFileSub.unsubscribe();
        if (this.editCloudFileSub != null) this.editCloudFileSub.unsubscribe();
        if (this.translateCloudFileSub != null) this.translateCloudFileSub.unsubscribe();
        if (this.deleteCloudFileSub != null) this.deleteCloudFileSub.unsubscribe();
        if (this.addCloudCommSub != null) this.addCloudCommSub.unsubscribe();
        if (this.deleteCloudCommSub != null) this.deleteCloudCommSub.unsubscribe();
        if (this.changeFileContentListingSub != null) this.changeFileContentListingSub.unsubscribe();
        if (this.changeCloudTreeDefaultLanguageSub != null) this.changeCloudTreeDefaultLanguageSub.unsubscribe();
        if (this.getTarifCategoriesForAllCountriesSub != null) this.getTarifCategoriesForAllCountriesSub.unsubscribe();
        if (this.getAvailableTechnologiesSub != null) this.getAvailableTechnologiesSub.unsubscribe();
        if (this.getCloudCommFileSub != null) this.getCloudCommFileSub.unsubscribe();
    }

    closeModal() {
        this.displayModalAddFile = false;
        this.displayModalEditFile = false;
        this.displayModalDeleteFile = false;
        this.displayModalTranslateFile = false;
        this.displayModalAddCommFile = false;
    }
}
